import React from 'react';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';

const adminTableHeader = [
  { id: 'MethodName', label: 'MÉTODO' },
  { id: 'HashCode', label: 'HASHCODE' },
  { id: 'QueueStatus', label: 'STATUS' },
  { id: 'ReferenceQuoteId', label: 'NUM. REFERENCIA' },
  { id: 'RequestDate', label: 'DATA' },
  { id: 'JsonToSend', label: 'JSON' },
];

const styles = ({
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblHeadT: {
    color: '#ffffff',
    fontSize: '14px'
  },
  tblBorder: {
    border: '2px solid #ffffff'
  },
  headerHeight: {
    height: '40px'
  },
  textCenter: {
    textAlign: 'center'
  },
  cellPadding: {
    paddingLeft: '16px'
  },
  tblSort: {
    height: '12px',
    width: '12px',
    margin: '0px 2px'
  }
});


class AdminSalesForceSyncTableHeader extends React.Component {

  render() {
    const { classes } = this.props;
    return (
      <TableHead className={classes.tblHead} >
        <TableRow className={classes.headerHeight} >
          {adminTableHeader.map(column => {
            return (
              <TableCell
                key={column.id}
                padding='none'
                className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, classes.cellPadding)}
              >
                <TableSortLabel
                  className={classes.tblHeadT}
                  classes={{ icon: classes.tblSort }}
                >
                  {column.label}
                </TableSortLabel>
              </TableCell>
            );
          }, this)}
          <TableCell key={'icon'} padding='none' className={classNames(classes.tblHeadT, classes.tblBorder, classes.textCenter, classes.cellPadding)} ></TableCell>
        </TableRow>
      </TableHead>
    );
  }
}

AdminSalesForceSyncTableHeader.propTypes = {
};

export default AdminSalesForceSyncTableHeader = withStyles(styles)(AdminSalesForceSyncTableHeader);


// WEBPACK FOOTER //
// ./src/components/Administration/AdminSalesForceSync/AdminSalesForceSyncTableHeader.js